// src/pages/Dashboard.js
import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getAllCattle } from '../utils/cattleService';
import { getCattleStats } from '../utils/excelUtils';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const { currentUser, userPlan, isPaid } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      const records = await getAllCattle(currentUser.uid);
      setStats(getCattleStats(records));
      setLoading(false);
    }
    load();
  }, [currentUser]);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  const renewalDate = userPlan?.renewalDate ? new Date(userPlan.renewalDate).toLocaleDateString('en-IN') : null;

  return (
    <div className="page-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1b5e20' }}>🐄 Dashboard</h1>
          <p style={{ color: '#6b7280', fontSize: 14 }}>Welcome, {userPlan?.name || currentUser.email}</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span className={`plan-badge ${isPaid ? 'plan-paid' : 'plan-free'}`}>
            {isPaid ? '⭐ Pro Plan' : '🆓 Free Plan'}
          </span>
          {isPaid && renewalDate && (
            <span style={{ fontSize: 12, color: '#6b7280' }}>Renews: {renewalDate}</span>
          )}
        </div>
      </div>

      {!isPaid && (
        <div className="upgrade-banner">
          <span style={{ fontSize: 28 }}>⚡</span>
          <div style={{ flex: 1 }}>
            <strong>Free Plan Limitations:</strong> You can add 5 records and edit 5 records.
            <br/>
            <span style={{ fontSize: 13, color: '#92400e' }}>
              Adds used: {userPlan?.addCount || 0}/5 &nbsp;|&nbsp; Edits used: {userPlan?.editCount || 0}/5
            </span>
          </div>
          <button className="btn btn-amber" onClick={() => navigate('/upgrade')}>Upgrade to Pro ₹</button>
        </div>
      )}

      {stats && (
        <div className="stat-bar">
          <div className="stat-card male">
            <div className="stat-number" style={{ color: '#1d4ed8' }}>{stats.bigMale}</div>
            <div className="stat-label">🐂 Big Male<br/><span style={{ fontSize: 10 }}>(Age &gt; 3 years)</span></div>
          </div>
          <div className="stat-card male">
            <div className="stat-number" style={{ color: '#3b82f6' }}>{stats.smallMale}</div>
            <div className="stat-label">🐃 Small Male<br/><span style={{ fontSize: 10 }}>(Age ≤ 3 years)</span></div>
          </div>
          <div className="stat-card female">
            <div className="stat-number" style={{ color: '#9d174d' }}>{stats.bigFemale}</div>
            <div className="stat-label">🐄 Big Female<br/><span style={{ fontSize: 10 }}>(Age &gt; 3 years)</span></div>
          </div>
          <div className="stat-card female">
            <div className="stat-number" style={{ color: '#db2777' }}>{stats.smallFemale}</div>
            <div className="stat-label">🐮 Small Female<br/><span style={{ fontSize: 10 }}>(Age ≤ 3 years)</span></div>
          </div>
          <div className="stat-card exited">
            <div className="stat-number" style={{ color: '#dc2626' }}>{stats.exited}</div>
            <div className="stat-label">🚪 Exited<br/><span style={{ fontSize: 10 }}>(Death/Sale/Donate)</span></div>
          </div>
          <div className="stat-card total">
            <div className="stat-number" style={{ color: '#d97706' }}>{stats.total}</div>
            <div className="stat-label">📊 Total Records<br/><span style={{ fontSize: 10 }}>(All time)</span></div>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginTop: 8 }}>
        {[
          { icon: '📥', title: 'Import Excel', desc: 'Import cattle records from Excel file', path: '/import', btn: 'Go to Import' },
          { icon: '📋', title: 'All Records', desc: 'View, edit and manage all cattle', path: '/cattle', btn: 'View Records' },
          { icon: '🔍', title: 'Search by Tag', desc: 'Find cattle by tag number', path: '/search', btn: 'Search' },
          { icon: '📤', title: 'Export Excel', desc: 'Export all records to Excel', path: '/cattle?export=1', btn: 'Export' },
        ].map(item => (
          <div key={item.path} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate(item.path)}>
            <div style={{ fontSize: 32, marginBottom: 10 }}>{item.icon}</div>
            <h3 style={{ fontWeight: 700, marginBottom: 6 }}>{item.title}</h3>
            <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 14 }}>{item.desc}</p>
            <button className="btn btn-primary" style={{ fontSize: 13 }}>{item.btn} →</button>
          </div>
        ))}
      </div>
    </div>
  );
}
